export default __webpack_public_path__ + "static/remote_w.8bd36c7c0394330ac34e9c6511d526a9.svg";